<mat-form-field class="full-width full-height overflow-hidden no-subscript" (click)="stopClickEvent($event)">
  <form [class.small]="isSmall">
    <input matInput vdwAutoFocus [autoSelect]="autoSelect" type="number" autocomplete="off" [formControl]="formControl" [min]="min" [max]="max" />
  </form>
</mat-form-field>
